<template>
  <div
    v-on-clickaway="close"
    :class="classes"
  >
    <div
      class="date-picker__field-wrapper"
      @click="onToggle"
    >
      <label v-if="label" class="date-picker__label">
        {{ label }}
        <span v-if="required" class="date-picker__label-required">*</span>
      </label>

      <div class="date-picker__field">
        <div class="date-picker__text">
          <span class="date-picker__date">{{ formatDate(date) ? formatDate(date) : placeholder }}</span>
        </div>
        <span class="date-picker__icon-calendar icon icon-calendar" />
      </div>
    </div>

    <transition name="slide-from-top-short">
      <div
        v-show="isOpened"
        class="date-picker__dropdown"
      >
        <div
          key="date-picker"
          class="datepicker__dropdown-date"
        >
          <!--          maximum-view="day"-->
          <datepicker
            ref="calendar"
            v-model="selectedDate"
            :language="datapickerLang"
            :disabledDates="disabledDates"
            :open-date="openDate"
            monday-first
            full-month-name
            inline
            format="dd/MM/yy"
            calendar-class="date-picker__calendar"
            wrapper-class="date-picker__wrap"
            @input="onSelect"
            @changedMonth="changedMonth"
          />
        </div>
      </div>
    </transition>

    <transition name="slide-from-top">
      <span
        v-if="error && errorMsg"
        class="datepicker__error-msg"
      >
        {{ errorMsg }}
      </span>
    </transition>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { uk, ro, ru, enUS } from 'date-fns/locale'
  import { format } from 'date-fns'
  import datepicker from 'vuejs-datepicker'
  import { uk as datapickerUk, ro as datapickerRo, ru as datapickerRu, en as datapickerEn } from 'vuejs-datepicker/dist/locale'
  import { mixin as clickaway } from 'vue-clickaway'
  import crud from './crud'

  export default {
    name: 'DatePicker',
    components: {
      datepicker
    },
    mixins: [clickaway, crud],
    props: {
      required: {
        type: Boolean,
        default: false
      },
      items: {
        type: Array,
        default: () => ([])
      },
      name: {
        type: String,
        default: ''
      },
      placeholder: String,
      reset: Boolean,
      timestamp: {
        type: Number
      },
      errorMsg: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      label: {
        type: String
      }
    },

    data () {
      return {
        disabledDates: {},
        openDate: '',
        isOpened: false,
        selectedDate: null,
        selectedLabel: null,
        isCollapsed: true,
        date: null,
        hours: 0,
        minutes: 0,
        isDropdownVisible: false,
        error: null,
        datapickerLang: datapickerUk,
        timepickerLang: uk
      }
    },

    computed: {
      ...mapState({
        serverTimestamp: (state) => state.globalData && state.globalData.currentTime,
        showroomPeriodEnabled: state => state.consultation.showroomPeriodEnabled,
        showroomPeriodDisabled: state => state.consultation.showroomPeriodDisabled,
        currentLang: state => state.currentLang,
        currentCountry: state => state.currentCountry
      }),
      classes () {
        return [
          'date-picker',
          {
            'datepicker_active': this.isDropdownVisible,
            'datepicker_error': this.error
          }
        ]
      },

      selected () {
        return this.selectedLabel
      }
    },

    watch: {
      errorMsg: {
        handler (msg) {
          this.error = !!msg
        },
        immediate: true
      },

      serverTimestamp () {
        this.setCalendarOptions()
      }
    },

    created () {
      if (this.currentLang === 'ro') {
        this.datapickerLang = datapickerRo
        this.timepickerLang = ro
      } else if (this.currentLang === 'ru') {
        this.datapickerLang = datapickerRu
        this.timepickerLang = ru
      } else if (this.currentLang === 'uk') {
        this.datapickerLang = datapickerUk
        this.timepickerLang = uk
      } else if (this.currentLang === 'en') {
        this.datapickerLang = datapickerEn
        this.timepickerLang = enUS
      } else {
        if (this.currentCountry === 'md') {
          this.datapickerLang = datapickerRo
          this.timepickerLang = ro
        } else if (this.currentCountry === 'ru') {
          this.datapickerLang = datapickerRu
          this.timepickerLang = ru
        }
      }

      this.setCalendarOptions()
    },

    mounted () {
      if (this.value) {
        this.onSelect(new Date(Math.floor(this.value * 1000.0)))
      }

      this.customDatePicker()
    },

    methods: {
      setCalendarOptions () {
        let dataUTC = new Date(this.serverTimestamp * 1000).setHours(0, 0, 0, 0) // not includes
        dataUTC = new Date(dataUTC)
        this.openDate = dataUTC
        this.$set(this.disabledDates, 'to', dataUTC)
        this.$set(this.disabledDates, 'days', this.disabledWeekDays())
        this.$set(this.disabledDates, 'dates', this.disabledDay())
      },

      changedMonth (e) {
        let date
        if (e instanceof Date) {
          date = new Date(e)
        } else if (e && e.timestamp) {
          date = new Date(e.timestamp)
        }

        const month = date.getMonth()
        const year = date.getFullYear()
        this.customDatePicker(this.datapickerLang._months[month], year)
      },
      customDatePicker (month, year) {
        const dayMonth = this.$el.querySelector('.day__month_btn.up')
        if (!dayMonth) return

        if (month || year) {
          dayMonth.innerHTML = this.renderDatePicker(month, year)
        } else {
          const [monthText, yearText] = dayMonth.innerHTML.split(' ')
          dayMonth.innerHTML = this.renderDatePicker(monthText, yearText)
        }
      },
      renderDatePicker (month, year) {
        this.month = month || this.month
        this.year = year || this.year
        return `
            ${this.month} <i class="custom-year">${this.year}</i>
          `
      },
      disabledDay () {
        const MINUTES_INTERVAL_TIME = 119
        const serverDateUTC = new Date(this.serverTimestamp * 1000)
        const serverDateTimestamp = new Date(this.serverTimestamp * 1000).getTime()
        let serverDay = serverDateUTC.getDay() - 1
        if (serverDay === -1) serverDay = 6

        const timiList = this.showroomPeriodEnabled[serverDay]

        const isTime = timiList.every(item => {
          const hours = Number(item.value.split(':')[0])
          const minutes = Number(item.value.split(':')[1])
          let itemTimestamp = new Date(this.serverTimestamp * 1000)
          itemTimestamp.setHours(hours, 0, 0, 0)
          itemTimestamp.setMinutes(minutes)
          itemTimestamp = itemTimestamp.getTime()
          return !(this.timeDifferenceMinute(itemTimestamp, serverDateTimestamp) >= MINUTES_INTERVAL_TIME)
        })

        if (isTime) {
          return [new Date(this.serverTimestamp * 1000)]
        }
      },

      disabledWeekDays () {
        return this.showroomPeriodDisabled.map(dayIndex => {
          return dayIndex === 6
            ? 0
            : dayIndex + 1
        })
      },

      onToggle () {
        this.error = false
        this.isOpened = !this.isOpened
      },

      formatDate (date) {
        if (date) {
          return format(date, 'd MMMM yyyy', { locale: this.timepickerLang }).replace(/ /g, ' ')
        }
      },

      onSelect (date) {
        this.date = date
        this.selectedLabel = date.toLocaleString('uk', {
          day: 'numeric',
          month: 'numeric',
          year: '2-digit'
        }).replace(/\./g, '-')

        this.selectedDate = date.getTime()
        this.$emit('input', this.selectedLabel)
        this.$emit('timestampInput', Math.floor(date.getTime() / 1000.0))
        this.close()
      },

      close () {
        this.isOpened = false
      },

      open () {
        this.isOpened = true
      }
    }
  }
</script>

<style lang="scss">
  $padding-for-error: 28px;

  .date-picker {
    position: relative;
    display: block;
    align-self: flex-start;
    min-width: 290px;
    padding-bottom: $padding-for-error;
    cursor: pointer;

    @media (max-width: 359px) {
      max-width: 100%;
    }

    &.disabled {
      pointer-events: none;
      opacity: 0.6;

      .datepicker__field-wrapper {
        pointer-events: none;
      }
    }

    &__label {
      display: inline-block;
      padding-bottom: 1em;
      font-family: "ToyotaType-Book", Arial, Helvetica, sans-serif;
      font-size: 16px;
      color: $c-gray-dark;

      &-required {
        color: $c-active-light;
      }
    }

    &__field {
      position: relative;
      display: block;
      width: 100%;
      min-height: 46px;
      padding: 0.938em 1.3em;
      font-size: 16px;
      line-height: 1;
      background-color: $c-gray-light;
      border-radius: 4px;
      outline: none;
      caret-color: $c-active-light;
      transition: 0.3s;

      &:focus {
        background-color: $c-gray;
      }

      @include hover {
        background-color: $c-gray;
      }
    }

    &__icon-calendar {
      position: absolute;
      top: 50%;
      right: 6px;
      padding: 0;
      font-size: 26px;
      transition: 0.3s;
      transform: translateY(-50%);

      &::before {
        color: #555;
      }
    }

    &__date {
      margin-right: 50px;
      font-family: "ToyotaType-Book", Arial, Helvetica, sans-serif;
      color: $c-gray-dark;
    }

    &__dropdown {
      position: absolute;
      top: calc(100% - 20px);
      left: 0;
      z-index: 9999;
      width: 100%;
      min-width: 336px;
      max-width: 336px;
      font-family: "ToyotaType-Book", Arial, Helvetica, sans-serif;
      cursor: default;
      user-select: none;
      background-color: $c-white;
      border-radius: 4px;
      box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.15);

      @media (max-width: 359px) {
        min-width: 295px;
        max-width: 295px;
      }

      .vdp-datepicker__calendar {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        margin: 0 auto;
        font-family: "ToyotaType-Book", Arial, Helvetica, sans-serif;
        background: transparent;
        border: none;

        @media (max-width: 359px) {
          padding-left: 27px;
          transform: translateX(-13px);
        }

        @media (max-width: 359px) {
          padding-left: 0;
          transform: translateX(1px);
        }

        header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          height: 48px;

          .day__month_btn.up {
            display: block;
            height: 100%;
            font-size: 24px;
            font-weight: 700;
            color: $c-gray-dark;
            transition: color 0.3s;

            &:hover {
              background: transparent;
            }

            .custom-year {
              font-size: 17px;
              font-weight: 400;
              color: $c-shadow-light;
            }
          }

          .month__year_btn.up {
            &:hover {
              background: transparent;
            }
          }
        }

        > div {
          display: flex;
          flex-wrap: wrap;
          width: 100%;
        }

        .prev,
        .next {
          height: 100%;
          overflow: hidden;
          background: url('../../assets/img/icons/chevron-gray.svg') no-repeat center;
          background-size: 15px;
          transition: background 0.3s, opacity 0.3s;
          transform: rotate(-180deg);

          &::after {
            display: none;
          }

          &:hover:not(.disabled) {
            background: url('../../assets/img/icons/chevron-gray.svg') no-repeat center;
            background-size: 15px;
            opacity: 1;
          }

          &.disabled {
            //opacity: 0.2;
          }
        }

        .prev {
          transform: rotate(0deg);
        }

        .cell {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 48px;
          height: 48px;
          padding: 0 5px;
          border: none;
          transition: all 0.3s;

          @media (max-width: 359px) {
            width: 42px;
            height: 42px;
          }

          &::before {
            position: absolute;
            top: 50%;
            left: 50%;
            z-index: -1;
            display: none;
            width: 30px;
            height: 30px;
            content: "";
            border-radius: 50%;
            transform: translateX(-50%) translateY(-50%);
          }

          &:not(.month) {
            &:not(.year) {
              &:nth-child(6) {
                background-color: $c-gray-extra-light-3 !important;
              }

              &:nth-child(7) {
                background-color: $c-gray-extra-light-3 !important;
              }
            }
          }

          &.month,
          &.year {
            width: 33.333%;

            &:hover {
              background: $c-gray-extra-light-3 !important;

              &::before {
                display: none;
              }
            }
          }

          &.selected {
            background: transparent !important;

            &:not(.month) {
              &:not(.year) {
                color: $c-white !important;

                &::before {
                  display: block;
                  background: $c-active-light;
                }
              }
            }
          }

          &.weekend {
            z-index: 1;
            background-color: $c-gray-extra-light-3 !important;

            &:hover {
              &:not(.selected) {
                &:not(.blank) {
                  &::before {
                    display: block;
                    background-color: $c-white !important;
                  }
                }
              }
            }
          }

          &:hover {
            &:not(.day-header) {
              border: none !important;

              &:not(.month) {
                &:not(.year) {
                  &:not(.selected) {
                    &:not(.blank) {
                      &::before {
                        display: block;
                        background-color: #eff0f0;
                      }
                    }
                  }
                }
              }
            }
          }

          // &.day {
          // width: 32px;
          // height: 32px;
          // padding: 0;
          // margin: 1px 6.2px 0;
          // line-height: 32px;
          // border-radius: 50%;

          // @media (max-width: 359px) {
          // margin: 1px 4.6px 0;
          // }
          //}

          &.day-header,
          &.blank {
            color: $c-gray-dark;

            &:hover {
              color: $c-gray-dark;
              cursor: default;
              background: transparent;
            }
          }

          &.day-header {
            border-bottom: 1px solid $c-gray;
          }

          &.disabled {
            color: $c-gray-medium;
            pointer-events: none;
          }
        }
      }

      &-button {
        &-container {
          display: flex;
          justify-content: center;
          margin: 20px 0;
        }

        background-color: $c-white;
        transition: all 0.4s;

        &:hover {
          background-color: $c-white;
          // box-shadow: 0 2px 10px 0 $c-gray-medium;
        }
      }

      &-time {
        padding-right: 10px;
        padding-left: 10px;

        &-title {
          margin: 10px 0 25px;
          text-align: center;
        }
      }

      &-times {
        display: flex;
        flex-wrap: wrap;
        margin-top: 10px;
      }

      &-time-item {
        flex: 0 1 20%;
        margin-bottom: 25px;
        color: $c-gray-dark;
        text-align: center;
        cursor: pointer;
        transition: color 0.3s;

        &:hover {
          color: $c-active;
        }

        &_disabled {
          color: $c-gray-medium;
          pointer-events: none;
        }

        &_selected {
          color: $c-active;
        }
      }

      &-back-to-calendar-button {
        display: flex;
        align-items: center;
        margin-right: 5px;
        cursor: pointer;

        &-arrow {
          width: 16px;
          height: 16px;
          margin-right: 10px;
          transition: 0.3s;
        }

        &-text {
          font-size: 12px;
          line-height: 16px;
          transition: color 0.3s;
        }

        &:hover {
          .datepicker__dropdown-back-to-calendar-button {
            &-text {
              color: $c-active;
            }

            &-arrow {
              stroke: $c-active;
            }
          }
        }
      }
    }

    &__error-msg {
      position: absolute;
      bottom: 23px;
      left: 0;
      z-index: 1;
      height: 0;
      font-size: 12px;
      color: $c-active-light;
    }

    &_error {
      .date-picker {
        &__field {
          background-color: $c-error-light;
        }
      }
    }

    &_active {
      .date-picker {
        &__field {
          background-color: $c-gray;
        }
      }
    }
  }
</style>
